import { render } from "./NcrmProducts.vue?vue&type=template&id=26bef498&scoped=true"
import script from "./NcrmProducts.vue?vue&type=script&lang=js"
export * from "./NcrmProducts.vue?vue&type=script&lang=js"

import "./NcrmProducts.vue?vue&type=style&index=0&id=26bef498&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bef498"]])

export default __exports__